import { AirportOptions } from "@/types/flightSearch";
import apiFetch from "@/utils/token-guard/apiFetch";

export async function flightLoadOptions(
  inputValue: string
): Promise<{ options: AirportOptions; hasMore: boolean }> {
  if (inputValue.length < 3) {
    return { options: [], hasMore: false };
  }
  const data = {
    starts_with: inputValue,
    limit: 10,
  };
  const encodedBody = Buffer.from(JSON.stringify(data)).toString("base64");
  try {
    const response = await apiFetch(`/api/flights/search/airport`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(encodedBody),
    });

    const data = await response;
     const transformedData = data.map((item: any) => ({
        label: `${item.airport_name} (${item.iata_code})`,  
        value: item.iata_code,
        country_code: item.country_code, 
        country_name: item.country_name, 
        city_name:item.city_name

      }));

    return { options: transformedData, hasMore: false };
  } catch (error) {
    console.error("Error loading options:", error);
    return { options: [], hasMore: false };
  }
}
